import { observer } from 'mobx-react'
import React, { Component } from 'react'

import Input from '../../../form/Input'
import Select from '../../../form/Select'
import Button from '../../../../UniformComponents/Button'

@observer
class Filters extends Component {
    changeField = ({ value, name }, filter) => {
        filter[name] = value
        console.log('changeField', value, name)
    }

    renderFilter = (filter) => {
        const { store } = this.props
        const { filterColumns } = store

        return (
            <div
                key={filter.id}
                style={{
                    display: 'flex',
                    gap: '20px',
                    marginBottom: '10px',
                }}
            >
                <div
                    className='delete-icon'
                    onClick={() => store.deleteFilter(filter.id)}
                >
                    <i className="fal fa-trash" />
                </div>
                <Select
                    name="column"
                    style={{ width: '250px' }}
                    options={filterColumns}
                    defaultValue={filter.column}
                    onBlur={(obj) => this.changeField(obj, filter)}
                />
                <Select
                    name="operator"
                    style={{ width: '200px' }}
                    options={store.filterOperators}
                    defaultValue={filter.operator}
                    onBlur={(obj) => this.changeField(obj, filter)}
                />
                <Input
                    name="value"
                    defaultValue={filter.value}
                    onBlur={(obj) => this.changeField(obj, filter)}
                />
            </div>
        )
    }

    render() {
        const { store } = this.props
        const { showFilters, filters } = store

        if (!showFilters) return null

        return (
            <div
                style={{
                    padding: '20px',
                    margin: '10px 0px',
                    border: '1px solid #777',
                    borderRadius: '5px',
                    width: '100%',
                }}
            >
                {filters.map(this.renderFilter)}
                <div>
                    <Button
                        label="Add Filter"
                        cssClass="tertiary regular"
                        onClick={store.addFilter}
                    />
                </div>
            </div>
        )
    }
}

export default Filters
